import { PageId } from 'constants/pages'
import { getPageById } from 'nove8/helpers/getPageById'
import { TStep } from 'nove8/types'

export const STEPS_WOOFZ22_V3: TStep[] = [
  {
    pageId: PageId.SEX_22V3,
  },
  {
    pageId: PageId.DOG_AGE_22V3,
  },
  {
    pageId: PageId.DOG_BREED_22V3,
  },
  {
    pageId: PageId.DOG_BREED_ID_22V3,
  },
  {
    pageId: PageId.URGE_22V3,
  },
  {
    pageId: PageId.COMMANDS_61_22V3,
  },
  {
    pageId: PageId.COMMANDS_62_22V3,
  },
  {
    pageId: PageId.COMMANDS_63_22V3,
  },
  {
    pageId: PageId.URGE_2_22V3,
  },
  {
    pageId: PageId.POTTY_22V3,
  },
  {
    pageId: PageId.BEHAVIOR_2_22V3,
  },
  {
    pageId: PageId.TRAINING_22V3,
  },
  {
    pageId: PageId.PREPARE_FLOW_22V3,
  },
  {
    pageId: PageId.DOG_STATISTICS_22V3,
  },
  {
    pageId: PageId.EMAIL_22V3,
  },
  {
    pageId: PageId.NEWSLETTER_URGE_22V3,
  },
  {
    pageId: PageId.LAST_CHANCE_OFFER_22V3,
  },
  {
    pageId: PageId.SUBSCRIPTIONS_22V3,
  },
  {
    pageId: PageId.PAYMENT_22V3,
  },
  {
    pageId: PageId.LAST_CHANCE_OFFER_2_22V3,
  },
  {
    pageId: PageId.CANCEL_OFFER_22V3,
  },
  {
    pageId: PageId.CHAT_UPSELL_22V3,
  },
  {
    pageId: PageId.UPSELL_22V3,
  },
  {
    pageId: PageId.UPSELL_FEEDING_GUIDE_22V3,
  },
  {
    pageId: PageId.UPSELL_EMOTIONAL_SUPPORT_22V3,
  },
  {
    pageId: PageId.UPSELL_PITPAT_22V3,
  },
  {
    pageId: PageId.ACCOUNT_NOVE8,
  },
  {
    pageId: PageId.DOWNLOAD_22V3,
  },
]

export const ALL_PAGES_WITH_PROGRESS_BAR_IDS = STEPS_WOOFZ22_V3.filter(
  ({ pageId }) => getPageById(pageId)?.progressBar,
)
  .filter(({ pageId }) => !getPageById(pageId)?.progressBarHidden)
  .map(({ pageId }) => pageId)

export const CONTROLLED_PAGES_WITH_PROGRESS_BAR_IDS = STEPS_WOOFZ22_V3.filter(
  ({ pageId }) => getPageById(pageId)?.progressBar === 'controlled',
).map(({ pageId }) => pageId)
